export default __webpack_public_path__ + "static/media/IMG_1140.d0f6a14e.jpg";